import { DocumentTypes } from '@core/constants/document-types';
import { Personal } from '../store/store.entity';

export const emptyPersonalObject: Partial<Personal> = {
  name: '',
  email: '',
  role: 'agency',
  document: '',
  document_type: DocumentTypes.CC,
  email_supervisor: '',
  address: '',
  mobile: '',
  reward: [],
  latitude: 0,
  longitude: 0,
};

export const CURRENT_PERSON_TARGET = 'currentTarget';
